import React, { Component } from "react";
import {
  Box,
  Meter,
  Text,
  Heading,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "grommet";
import HeatMap from "./HeatMap";
import { UserPolice } from "grommet-icons";

export class GuardOverview extends Component {
  state = {
    dataPoints: [0, 0],
  };
  componentDidMount = () => {
    console.log("guard overview props", this.props);
    this.calculatePercentOnTime(this.props.shiftGuard);
    //this.filterSmallList(this.props.shiftGuard, this.props.smallList);
  };
  /*
  filterSmallList = (shiftGuard, smallList) => {
    let dataPoints = [];
    shiftGuard.RoleInstances.forEach(roleInstance => {
      console.log(roleInstance);
      if (roleInstance.Role.Type === "Patrol") {
        smallList.forEach(location => {
          console.log(location);
          if (
            location.RoleInstanceId === roleInstance.Id &&
            location.Latitude !== 0 &&
            location.Longitude !== 18
          ) {
            const dataPoint = new window.google.maps.LatLng(
              location.Latitude,
              location.Longitude
            );
            dataPoints.push(dataPoint);
          }
        });
      }
    });
    console.log(dataPoints);
    const newState = {
      ...this.state,
      dataPoints: dataPoints
    };

    this.setState(newState);
  };*/

  calculatePercentOnTime = (shiftGuard) => {
    let routeInstances = [];
    let routeInstancesOnTime = 0;
    shiftGuard.RoleInstances.forEach((roleInstance) => {
      if (roleInstance.Role.Type === "Patrol") {
        const newArray = routeInstances.concat(roleInstance.RouteInstances);
        routeInstances = newArray;
      }
    });

    routeInstances.forEach((routeInstance) => {
      const idealTime = routeInstance.Route.IdealTimeSeconds;
      const timeTaken = this.calculateTimeTaken(
        routeInstance.StartTimeDate,
        routeInstance.EndTimeDate
      );
      if (routeInstance.isOnTime) {
        routeInstancesOnTime++;
      }
    });

    let perCentOnTime = (100 * routeInstancesOnTime) / routeInstances.length;

    if (routeInstances.length === 0) {
      perCentOnTime = 0;
    }

    return perCentOnTime;
  };

  calculateTimeTaken = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);
    return difference / 1000;
  };
  toHHMMSS = (secs) => {
    var sec_num = parseInt(secs, 10);
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor(sec_num / 60) % 60;
    var seconds = sec_num % 60;

    return [hours, minutes, seconds]
      .map((v) => (v < 10 ? "0" + v : v))
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  };

  downloadImage = (guardName, guardId, buildingId, buildingName) => {};

  generateHeatmapRows = (roleIds, roleData, mapId) => {
    let separateElements = [];
    for (let i = 1; i < roleIds.length; i += 2) {
      let oneRow = [];
      oneRow.push(
        roleIds.slice(i, i + 2).map((roleId) => {
          console.log("Output: : GuardOverview -> render -> roleId", roleId);
          let roleDataObject = roleData[roleId];
          console.log(
            "Output: : GuardOverview -> render -> roleDataObject",
            roleDataObject
          );
          const roleDataPoints = roleDataObject.roleDataPoints;
          console.log(
            "Output: : GuardOverview -> render -> roleDataPoints",
            roleDataPoints
          );
          let roleTitle = roleDataObject.title;
          return (
            <Box
              direction="column"
              margin="small"
              align="center"
              justify="center"
            >
              <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
                {roleTitle}
              </Text>
              <HeatMap
                firebase={this.props.firebase}
                zoomCorrection={1.03}
                mapId={mapId + "Role" + roleId}
                currentBuilding={this.props.currentBuilding}
                floorOverlays={this.props.floorOverlays}
                dataPoints={roleDataPoints}
                height={"300px"}
                width={"300px"}
              ></HeatMap>
            </Box>
          );
        })
      );
      separateElements.push(
        oneRow.map((itm) => {
          return (
            <Box direction="row" margin="small" align="center" justify="center">
              {itm}
            </Box>
          );
        })
      );
    }

    return separateElements;
  };

  haversine_distance = (pos1, pos2) => {
    var R = 3958.8; // Radius of the Earth in miles
    var rlat1 = pos1.lat() * (Math.PI / 180); // Convert degrees to radians
    var rlat2 = pos2.lat() * (Math.PI / 180); // Convert degrees to radians
    var difflat = rlat2 - rlat1; // Radian difference (latitudes)
    var difflon = (pos2.lng() - pos1.lng()) * (Math.PI / 180); // Radian difference (longitudes)

    var d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
              Math.cos(rlat2) *
              Math.sin(difflon / 2) *
              Math.sin(difflon / 2)
        )
      );
    return d;
  };

  calcRoamDistance = (shiftGuard) => {
    let roamDistanceWalked = 0;
    shiftGuard.RoleInstances.forEach((roleInstance) => {
      if (roleInstance.Role.Type === "Roam") {
      }
    });
  };
  render() {
    console.log("overview props", this.props);
    const perCentOnTime = Math.round(
      this.calculatePercentOnTime(this.props.shiftGuard)
    );
    const roamDistanceWalked = this.calcRoamDistance(this.props.shiftGuard);
    const perCentOnTimeNumber = Number(perCentOnTime);
    const length = this.props.dataPoints.length;
    let image = <UserPolice size="large"></UserPolice>;
    const mapId = "Patrol" + this.props.shiftGuard.Gaurd.Id;
    let imageContainer;
    const patrolTime = this.toHHMMSS(this.props.patrolTime);
    const roamTime = this.toHHMMSS(this.props.roamTime);
    const stationTime = this.toHHMMSS(this.props.stationTime);
    if (typeof this.props.shiftGuard.Gaurd.Url === "string") {
      imageContainer = (
        <Box margin="small" align="center" direction="column" justify="center">
          <img
            height="150px"
            width="150px"
            object-fit="cover"
            src={this.props.shiftGuard.Gaurd.Url}
          />
        </Box>
      );
    } else {
      imageContainer = (
        <Box margin="small" align="center" direction="column" justify="center">
          <UserPolice size="large"></UserPolice>
        </Box>
      );
    }
    const roleIds = this.props.roleIds;
    let roleData = this.props.roleData;
    let roleHeatMaps;
    if (typeof roleIds !== "object" || roleIds.length === 0) {
      console.log("was none");
      roleHeatMaps = (
        <Box direction="column" margin="small" align="center" justify="center">
          <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
            Entire Shift
          </Text>
          <HeatMap
            firebase={this.props.firebase}
            zoomCorrection={1.03}
            mapId={mapId + "shift"}
            currentBuilding={this.props.currentBuilding}
            dataPoints={this.props.dataPoints}
            height={"300px"}
            width={"300px"}
            floorOverlays={this.props.floorOverlays}
          ></HeatMap>
        </Box>
      );
    } else if (typeof roleIds === "object" && roleIds.length === 1) {
      console.log("just one");
      const roleId = roleIds[0];
      console.log("Output: : GuardOverview -> render -> roleId", roleId);
      const roleDataObject = roleData[roleId];
      console.log(
        "Output: : GuardOverview -> render -> roleDataObject",
        roleDataObject
      );
      const roleDataPoints = roleDataObject.roleDataPoints;
      console.log(
        "Output: : GuardOverview -> render -> roleDataPoints",
        roleDataPoints
      );
      const roleTitle = roleDataObject.title;
      const roleType = roleDataObject.type;
      console.log("Output: : GuardOverview -> render -> roleTitle", roleTitle);
      roleHeatMaps = (
        <Box direction="row" margin="small" align="center" justify="center">
          <Box
            direction="column"
            margin="small"
            align="center"
            justify="center"
          >
            <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
              Entire Shift
            </Text>
            <HeatMap
              zoomCorrection={1.03}
              mapId={mapId + "shift" + this.props.shiftGuard.Id}
              currentBuilding={this.props.currentBuilding}
              dataPoints={this.props.dataPoints}
              height={"300px"}
              width={"300px"}
              firebase={this.props.firebase}
              floorOverlays={this.props.floorOverlays}
            ></HeatMap>
          </Box>
          <Box
            direction="column"
            margin="small"
            align="center"
            justify="center"
          >
            <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
              {roleType + ": " + roleTitle}
            </Text>
            <HeatMap
              zoomCorrection={1.03}
              mapId={mapId + "Role" + roleId}
              currentBuilding={this.props.currentBuilding}
              dataPoints={roleDataPoints}
              height={"300px"}
              width={"300px"}
              firebase={this.props.firebase}
              floorOverlays={this.props.floorOverlays}
            ></HeatMap>
          </Box>
        </Box>
      );
    } else {
      console.log("more than one");
      let roleId = roleIds[0];
      console.log("Output: : GuardOverview -> render -> roleId", roleId);
      let roleDataObject = roleData[roleId];
      console.log(
        "Output: : GuardOverview -> render -> roleDataObject",
        roleDataObject
      );
      const roleDataPoints = roleDataObject.roleDataPoints;
      console.log(
        "Output: : GuardOverview -> render -> roleDataPoints",
        roleDataPoints
      );
      let roleTitle = roleDataObject.title;
      const roleType = roleDataObject.type;
      console.log("Output: : GuardOverview -> render -> roleTitle", roleTitle);
      delete roleData[roleId];
      roleHeatMaps = (
        <Box direction="column">
          <Box direction="row" margin="small" align="center" justify="center">
            <Box
              direction="column"
              margin="small"
              align="center"
              justify="center"
            >
              <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
                Entire Shift
              </Text>
              <HeatMap
                zoomCorrection={1.03}
                mapId={mapId + "shift" + this.props.shiftGuard.Id}
                currentBuilding={this.props.currentBuilding}
                dataPoints={this.props.dataPoints}
                height={"300px"}
                firebase={this.props.firebase}
                floorOverlays={this.props.floorOverlays}
                width={"300px"}
              ></HeatMap>
            </Box>
            <Box
              direction="column"
              margin="small"
              align="center"
              justify="center"
            >
              <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
                {roleType + ": " + roleTitle}
              </Text>
              <HeatMap
                zoomCorrection={1.03}
                mapId={mapId + "Role" + roleId}
                currentBuilding={this.props.currentBuilding}
                dataPoints={roleDataPoints}
                height={"300px"}
                firebase={this.props.firebase}
                width={"300px"}
                floorOverlays={this.props.floorOverlays}
              ></HeatMap>
            </Box>
          </Box>

          {this.generateHeatmapRows(roleIds, roleData, mapId)}
        </Box>
      );
    }

    const roleHeatMapContainer = <Box direction="column">{roleHeatMaps}</Box>;
    return (
      <Box
        direction="column"
        margin="small"
        align="center"
        justify="center"
        border={{ color: "black", size: "small" }}
      >
        <Text weight="bold" size="medium" margin="small">
          {this.props.shiftGuard.Gaurd.GaurdFirstName}
        </Text>
        <Box
          direction="row"
          margin="small"
          alignSelf="center"
          align="center"
          justify="center"
        >
          {imageContainer}

          <Box
            margin="small"
            align="center"
            direction="column"
            justify="center"
          >
            <Text>Time Spent:</Text>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Patrolling</TableCell>
                  <TableCell>{patrolTime}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Roaming</TableCell>
                  <TableCell>{roamTime}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Stationed</TableCell>
                  <TableCell>{stationTime}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>

          <Box>
            <Meter
              alignSelf="center"
              values={[
                {
                  value: perCentOnTimeNumber,
                  label: "test",
                  highlight: true,
                },
              ]}
              type="circle"
              thickness="small"
              size="xsmall"
              round={true}
              background="active"
            />
            <Box
              align="center"
              justify="center"
              direction="column"
              fill="vertical"
              alignSelf="center"
            >
              <Text weight="bold" truncate={true} textAlign="center">
                {perCentOnTimeNumber + "% on time"}
              </Text>
            </Box>
          </Box>
        </Box>
        {/*<Box direction="row" margin="small" align="center" justify="center">
          <Box
            direction="column"
            margin="small"
            align="center"
            justify="center"
          >
            <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
              Shift
            </Text>
            <HeatMap
              zoomCorrection={1.03}
              mapId={mapId + "shift"}
              currentBuilding={this.props.currentBuilding}
              dataPoints={this.props.dataPoints}
              height={"300px"}
              width={"300px"}
            ></HeatMap>
          </Box>
          <Box
            direction="column"
            margin="small"
            align="center"
            justify="center"
          >
            <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
              Patrol
            </Text>
            <HeatMap
              zoomCorrection={1.03}
              mapId={mapId + "Patrol"}
              currentBuilding={this.props.currentBuilding}
              dataPoints={this.props.patrolDataPoints}
              height={"300px"}
              width={"300px"}
            ></HeatMap>
          </Box>
        </Box>
        <Box direction="row" margin="small" align="center" justify="center">
          <Box
            direction="column"
            margin="small"
            align="center"
            justify="center"
          >
            <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
              Roaming
            </Text>
            <HeatMap
              zoomCorrection={1.03}
              mapId={mapId + "Roam"}
              currentBuilding={this.props.currentBuilding}
              dataPoints={this.props.roamDataPoints}
              height={"300px"}
              width={"300px"}
            ></HeatMap>
          </Box>
          <Box
            direction="column"
            margin="small"
            align="center"
            justify="center"
          >
            <Text weight="bold" size="medium" margin={{ bottom: "small" }}>
              Stationed
            </Text>
            <HeatMap
              zoomCorrection={1.03}
              mapId={mapId + "Station"}
              currentBuilding={this.props.currentBuilding}
              dataPoints={this.props.stationDataPoints}
              height={"300px"}
              width={"300px"}
            ></HeatMap>
          </Box>
        </Box>*/}
        {roleHeatMapContainer}
      </Box>
    );
  }
}

export default GuardOverview;
